/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Label_NameInputs */

const et_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täisnimi`)
};

const en_contact_label_name = /** @type {(inputs: Contact_Label_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Contact_Label_NameInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_label_name = /** @type {((inputs?: Contact_Label_NameInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Label_NameInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_label_name(inputs)
	return en_contact_label_name(inputs)
});